import React from "react";
import { Popover } from "antd";
import {
  getSymbolById,
  SYMBOL_SIZE,
  SYMBOL_HALF_SIZE,
} from "../../FloorPlanModal/utils/symbolTypes";
import { symbolTransform } from "../../FloorPlanModal/utils/symbolTransform";

// `position` here is always the TRUE center (see utils/viewport.js). The
// vertical_line branch below draws a bar so it wants that center directly
// (centerX = position.x, no offset). The default branch further down
// positions a SYMBOL_SIZE (24px) glyph via a plain `translate(x, y)` with no
// -50%/-50% centering -- i.e. it needs the glyph's TOP-LEFT CORNER, not its
// center -- so it must subtract SYMBOL_HALF_SIZE itself. (Using
// STATION_HALF_SIZE there would be wrong: that's half of the unrelated 12px
// station glyph, not this 24px symbol glyph.)
const StaticSymbol = ({ symbol, layoutType, position, viewport }) => {
  const symbolType = getSymbolById(symbol.symbol_type);

  if (!symbolType) {
    return null;
  }

  if (
    symbolType.renderType === "vertical_line" &&
    layoutType === "tunnel" &&
    viewport
  ) {
    const upperLaneY = viewport.laneYPx("upper");
    const lowerLaneY = viewport.laneYPx("lower");
    const centerX = position?.x ?? 0;
    return (
      <div
        style={{ position: "absolute", top: 0, left: 0, width: 0, height: 0 }}
      >
        <div
          style={{
            position: "absolute",
            left: centerX - 2,
            top: upperLaneY,
            width: 4,
            height: lowerLaneY - upperLaneY,
            backgroundColor: symbolType.color,
            borderRadius: 1,
            opacity: 0.7,
            cursor: "default",
            pointerEvents: "auto",
          }}
        />
      </div>
    );
  }

  const popoverContent = (
    <div style={{ minWidth: 150 }}>
      <div style={{ marginBottom: 8 }}>
        <strong>{symbolType.name}</strong>
      </div>
      <div style={{ fontSize: 12, color: "#666", marginBottom: 8 }}>
        <div>類型: {symbolType.category}</div>
        <div>
          位置: {symbol.position_meters?.x?.toFixed(2)}m,{" "}
          {symbol.position_meters?.y?.toFixed(2)}m
        </div>
        {symbol.label && <div>標籤: {symbol.label}</div>}
      </div>
    </div>
  );

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          cursor: "default",
          userSelect: "none",
          pointerEvents: "auto",
          display: "block",
          width: SYMBOL_SIZE,
          height: SYMBOL_SIZE,
          padding: 0,
          margin: 0,
          border: "none",
          boxSizing: "border-box",
          lineHeight: 0,
          transform: `translate(${(position?.x ?? 0) - SYMBOL_HALF_SIZE}px, ${(position?.y ?? 0) - SYMBOL_HALF_SIZE}px)`,
        }}
      >
        <Popover content={popoverContent} trigger="hover" placement="top">
          <div
            style={{
              width: SYMBOL_SIZE,
              height: SYMBOL_SIZE,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: SYMBOL_SIZE - 4,
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              borderRadius: "4px",
              border: `2px solid ${symbolType.color}`,
              boxShadow: `0 2px 6px ${symbolType.color}66`,
              transition: "all 0.2s ease",
              transform: symbolTransform(symbol.rotation, 1),
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = symbolTransform(
                symbol.rotation,
                1.2,
              );
              e.currentTarget.style.boxShadow = `0 0 0 2px ${symbolType.color}, 0 2px 8px ${symbolType.color}88`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = symbolTransform(
                symbol.rotation,
                1,
              );
              e.currentTarget.style.boxShadow = `0 2px 6px ${symbolType.color}66`;
            }}
          >
            {symbolType.icon && <symbolType.icon size={SYMBOL_SIZE - 4} />}
          </div>
        </Popover>
      </div>
    </div>
  );
};

export default StaticSymbol;
